import React, { Component } from "react";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import { SideBar, NavBar, Footer, TitleAndDescription } from "../../components";
import "react-toastify/dist/ReactToastify.css";
import Pagination from "react-js-pagination";
import { Link } from "react-router-dom";
import { UncontrolledTooltip } from "reactstrap";
const { formatarReal } = require("../../utils");

class AbcCliente extends Component {
  constructor() {
    super();
    this.load = this.load.bind(this);
    this.loadClientes = this.loadClientes.bind(this);
    this.paginar = this.paginar.bind(this);
    this.onChangePeriodo = this.onChangePeriodo.bind(this);
    this.state = {
      periodo: "mesAtual", //mesAnterior
      clientes: [],
      clientesBkp: [],
      paginacao: {
        pagina: 1,
        limite: 10,
      },
      totalizador: 0,
    };
  }

  async componentDidMount() {
    await this.load();
  }

  async load() {
    await this.loadClientes();
  }

  async loadClientes() {
    await axios
      .get(
        `${this.props.getBaseUrlApi()}/relatorios/abc-clientes?periodo=${
          this.state.periodo
        }`,
        this.props.parameters()
      )
      .then((response) => {
        this.setState(
          {
            clientesBkp: response.data.clientes,
            totalizador: response.data.clientes.length,
          },
          () => {
            this.paginar(1);
          }
        );
      })
      .catch((error) => {
        console.log(error);
        if (error.response !== undefined) {
          if (error.response.status === 401) {
            this.props.logout();
          }
          if (error.response.status === 403) {
            this.props.history.push('/home')
          }
        }
      });
  }

  notificar(type, message) {
    toast[type](message, {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
    });
  }

  paginar(paginaAlterar) {
    this.setState({ paginacao: { pagina: paginaAlterar, limite: 10 } }, () => {
      let clientes = [...this.state.clientesBkp];
      paginaAlterar = paginaAlterar - 1;
      clientes = clientes.slice(
        paginaAlterar * this.state.paginacao.limite,
        (paginaAlterar + 1) * this.state.paginacao.limite
      );
      paginaAlterar = paginaAlterar + 1;

      this.setState({ clientes });
    });
  }

  onChangePeriodo(e) {
    this.setState({ periodo: e.target.value }, () => {
      this.loadClientes();
    });
  }

  render() {
    return (
      <React.Fragment>
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnVisibilityChange
          draggable
          pauseOnHover
        />
        <div className="container-scroller font-app">
          <NavBar title="ABC de Clientes"/>
          <div className="container-fluid page-body-wrapper">
            <SideBar itemActive={"abc-cliente"} />

            <div className="main-panel">
              <div className="content-wrapper">
                {/* <TitleAndDescription
                  title="ABC de Clientes"
                  description="Informações de curva ABC de clientes"
                /> */}

                <div className="row">
                  <div className="col-md-12 grid-margin stretch-card">
                    <div className="card">
                      <div className="card-body dashboard-tabs p-0">
                        <div className="tab-content py-0 px-0">
                          <div
                            className="tab-pane fade show active"
                            id="overview"
                            role="tabpanel"
                            aria-labelledby="overview-tab"
                          >
                            <div className="d-flex flex-wrap justify-content-xl-between">
                              <div className="d-none d-xl-flex border-md-right flex-grow-1 align-items-center justify-content-center p-3 item">
                                <img
                                  src="images/calendar.png"
                                  alt="logo"
                                  className="mr-3 mx-3"
                                  style={{ width: "28px" }}
                                />
                                <div className="d-flex flex-column justify-content-around">
                                  <small className="mb-1 text-muted">
                                    Período
                                  </small>
                                  <div className="dropdown">
                                    <select
                                      className="no-border"
                                      style={{ fontWeight: "bold" }}
                                      value={this.state.periodo}
                                      onChange={(e) => this.onChangePeriodo(e)}
                                    >
                                      <option value="mesAtual">
                                        Mês Atual
                                      </option>
                                      <option value="mesAnterior">
                                        Mês Anterior
                                      </option>
                                    </select>
                                    <div
                                      className="dropdown-menu"
                                      aria-labelledby="dropdownMenuLinkA"
                                    >
                                      <a className="dropdown-item" href="#">
                                        Mês anterior
                                      </a>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            className="tab-pane fade"
                            id="sales"
                            role="tabpanel"
                            aria-labelledby="sales-tab"
                          >
                            <div className="d-flex flex-wrap justify-content-xl-between">
                              <div className="d-none d-xl-flex border-md-right flex-grow-1 align-items-center justify-content-center p-3 item">
                                <img
                                  src="images/calendar.png"
                                  alt="logo"
                                  className="mr-3 mx-3"
                                  style={{ width: "28px" }}
                                />
                                <div className="d-flex flex-column justify-content-around">
                                  <small className="mb-1 text-muted">
                                    Período
                                  </small>
                                  <div className="dropdown">
                                    <a
                                      className="btn btn-secondary dropdown-toggle p-0 bg-transparent border-0 text-dark shadow-none font-weight-medium"
                                      href="#"
                                      role="button"
                                      id="dropdownMenuLinkA"
                                      data-toggle="dropdown"
                                      aria-haspopup="true"
                                      aria-expanded="false"
                                    >
                                      <h5 className="mb-0 d-inline-block">
                                        Mês atual
                                      </h5>
                                    </a>
                                    <div
                                      className="dropdown-menu"
                                      aria-labelledby="dropdownMenuLinkA"
                                    >
                                      <a className="dropdown-item" href="#">
                                        Mês anterior
                                      </a>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="d-flex border-md-right flex-grow-1 align-items-center justify-content-center p-3 item">
                                <i className="mdi mdi-currency-usd mr-3 icon-lg text-danger font-size-30 font-000"></i>
                                <div className="d-flex flex-column justify-content-around">
                                  <small className="mb-1 text-muted">
                                    Total de orçamentos
                                  </small>
                                  <h5 className="mr-2 mb-0">30.020,00</h5>
                                </div>
                              </div>
                              <div className="d-flex border-md-right flex-grow-1 align-items-center justify-content-center p-3 item">
                                <img
                                  src="images/button.png"
                                  alt="logo"
                                  className="mr-3 mx-3"
                                  style={{ width: "25px" }}
                                />
                                <div className="d-flex flex-column justify-content-around">
                                  <small className="mb-1 text-muted">
                                    N de orçamentos
                                  </small>
                                  <h5 className="mr-2 mb-0">30</h5>
                                </div>
                              </div>
                              <div className="d-flex border-md-right flex-grow-1 align-items-center justify-content-center p-3 item">
                                <img
                                  src="images/trash.png"
                                  alt="logo"
                                  className="mr-3 mx-3"
                                  style={{ width: "25px" }}
                                />
                                <div className="d-flex flex-column justify-content-around">
                                  <small className="mb-1 text-muted">
                                    Cancelados
                                  </small>
                                  <h5 className="mr-2 mb-0">2</h5>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            className="tab-pane fade"
                            id="purchases"
                            role="tabpanel"
                            aria-labelledby="purchases-tab"
                          >
                            <div className="d-flex flex-wrap justify-content-xl-between">
                              <div className="d-none d-xl-flex border-md-right flex-grow-1 align-items-center justify-content-center p-3 item">
                                <i className="mdi mdi-calendar-heart icon-lg mr-3 text-primary"></i>
                                <div className="d-flex flex-column justify-content-around">
                                  <small className="mb-1 text-muted">
                                    Start date
                                  </small>
                                  <div className="dropdown">
                                    <a
                                      className="btn btn-secondary dropdown-toggle p-0 bg-transparent border-0 text-dark shadow-none font-weight-medium"
                                      href="#"
                                      role="button"
                                      id="dropdownMenuLinkA"
                                      data-toggle="dropdown"
                                      aria-haspopup="true"
                                      aria-expanded="false"
                                    >
                                      <h5 className="mb-0 d-inline-block">
                                        26 Jul 2018
                                      </h5>
                                    </a>
                                    <div
                                      className="dropdown-menu"
                                      aria-labelledby="dropdownMenuLinkA"
                                    >
                                      <a className="dropdown-item" href="#">
                                        12 Aug 2018
                                      </a>
                                      <a className="dropdown-item" href="#">
                                        22 Sep 2018
                                      </a>
                                      <a className="dropdown-item" href="#">
                                        21 Oct 2018
                                      </a>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="d-flex border-md-right flex-grow-1 align-items-center justify-content-center p-3 item">
                                <i className="mdi mdi-currency-usd mr-3 icon-lg text-danger"></i>
                                <div className="d-flex flex-column justify-content-around">
                                  <small className="mb-1 text-muted">
                                    Revenue
                                  </small>
                                  <h5 className="mr-2 mb-0">$577545</h5>
                                </div>
                              </div>
                              <div className="d-flex border-md-right flex-grow-1 align-items-center justify-content-center p-3 item">
                                <i className="mdi mdi-eye mr-3 icon-lg text-success"></i>
                                <div className="d-flex flex-column justify-content-around">
                                  <small className="mb-1 text-muted">
                                    Total views
                                  </small>
                                  <h5 className="mr-2 mb-0">9833550</h5>
                                </div>
                              </div>
                              <div className="d-flex border-md-right flex-grow-1 align-items-center justify-content-center p-3 item">
                                <i className="mdi mdi-download mr-3 icon-lg text-warning"></i>
                                <div className="d-flex flex-column justify-content-around">
                                  <small className="mb-1 text-muted">
                                    Downloads
                                  </small>
                                  <h5 className="mr-2 mb-0">2233783</h5>
                                </div>
                              </div>
                              <div className="d-flex py-3 border-md-right flex-grow-1 align-items-center justify-content-center p-3 item">
                                <i className="mdi mdi-flag mr-3 icon-lg text-danger"></i>
                                <div className="d-flex flex-column justify-content-around">
                                  <small className="mb-1 text-muted">
                                    Flagged
                                  </small>
                                  <h5 className="mr-2 mb-0">3497843</h5>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {this.state.clientes.length > 0 && (
                  <React.Fragment>
                    <div className="row">
                      <div className="col-md-12 stretch-card">
                        <div className="card">
                          <div className="card-body">
                            <div className="table-responsive">
                              <table
                                id="recent-purchases-listing"
                                className="table"
                              >
                                <thead>
                                  <tr>
                                    <th>Código</th>
                                    <th>Cliente</th>
                                    <th className="text-right">Valor</th>
                                    <th className="text-right">Ações</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {this.state.clientes.map((cliente, key) => (
                                    <tr key={key}>
                                      <td style={{ fontWeight: "bold" }}>
                                        <Link
                                          to={`/cliente-detalhe?id=${cliente._id}`}
                                          style={{ color: "inherit" }}
                                        >
                                          #{cliente.cod}
                                        </Link>
                                      </td>
                                      <td>
                                        {cliente.desc} <br />{" "}
                                        <span className="font-size-13 font-999">
                                          CNPJ: {cliente.cnpjCpf}
                                        </span>
                                      </td>
                                      <td className="text-right">
                                        R$ {formatarReal(cliente.valorTotal)}
                                      </td>
                                      <td className="text-right">
                                        <Link
                                          to={`/cliente-detalhe?id=${cliente._id}`}
                                        >
                                          <i
                                            className="fa fa-search-plus font-000"
                                            style={{ cursor: "pointer" }}
                                            id={`detalhar-cliente-${cliente._id}`}
                                          ></i>

                                          <UncontrolledTooltip
                                            placement="right"
                                            target={`detalhar-cliente-${cliente._id}`}
                                          >
                                            Detalhar cliente
                                          </UncontrolledTooltip>
                                        </Link>
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>

                            <div className="paginacao">
                              <Pagination
                                prevPageText={
                                  <i className="fa fa-angle-left" />
                                }
                                nextPageText={
                                  <i className="fa fa-angle-right" />
                                }
                                firstPageText={
                                  <i className="fa fa-angle-double-left" />
                                }
                                lastPageText={
                                  <i className="fa fa-angle-double-right" />
                                }
                                activePage={this.state.paginacao.pagina}
                                itemsCountPerPage={this.state.paginacao.limite}
                                totalItemsCount={this.state.totalizador}
                                onChange={(pagina) => this.paginar(pagina)}
                                itemClass="page-item"
                                linkClass="page-link"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </React.Fragment>
                )}
              </div>
              <Footer />
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default AbcCliente;
